import { PropertyInformationResponse } from '../components/Property/types'
import { fetchClientPropertyConfig, fetchPropertyInformation } from '../services/propertyService'
import type { Feature } from 'geojson'
import { atom } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'

export const selectedAssetIdAtom = atom<string | null>(null)
export const shownHazardLayersAtom = atom<string[]>([])
export const selectedAssetFeatureAtom = atom<Feature | null>(null)

export const propertyConfigAtom = atomWithQuery(() => ({
  queryKey: ['propertyConfig'],
  queryFn: fetchClientPropertyConfig,
}))

export const reportHazardsAtom = atom((get) => {
  const config = get(propertyConfigAtom)
  if (!config.data?.report_hazards) return []

  const simplified_report_hazards = config.data.report_hazards.map((group) => ({
    ...group,
    hazards: group.hazards.map((hazard) => ({
      ...hazard,
      scenarios: hazard.scenarios?.slice(0, 1) || [],
      layer_ids: hazard.layer_ids?.slice(0, 1) || [],
    })),
  }))

  return simplified_report_hazards
})

export const propertyAssetTypeAtom = atom((get) => {
  const config = get(propertyConfigAtom)
  return config.data?.asset_type || null
})

export const selectedAssetInfoAtom = atomWithQuery<PropertyInformationResponse>((get) => {
  const selectedAssetId = get(selectedAssetIdAtom)
  const assetType = get(propertyAssetTypeAtom)

  return {
    queryKey: ['propertyInformation', assetType, selectedAssetId],
    queryFn: async () => {
      if (!assetType || !selectedAssetId) {
        throw new Error('Missing asset type or ID')
      }
      return fetchPropertyInformation(assetType, selectedAssetId)
    },
    enabled: !!assetType && !!selectedAssetId,
  }
})

selectedAssetIdAtom.debugLabel = 'selectedAssetIdAtom'
shownHazardLayersAtom.debugLabel = 'shownHazardLayersAtom'
selectedAssetFeatureAtom.debugLabel = 'selectedAssetFeatureAtom'
propertyConfigAtom.debugLabel = 'propertyConfigAtom'
reportHazardsAtom.debugLabel = 'reportHazardsAtom'
propertyAssetTypeAtom.debugLabel = 'propertyAssetTypeAtom'
selectedAssetInfoAtom.debugLabel = 'selectedAssetInfoAtom'
